module.exports = __webpack_public_path__ + "img/digital-marketting.f61711f5.png";